import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Application  {
    _originalTypeClassName = "zAppDevManager.BO.Application";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Application.translate = translateService;
}
this.ProjectRights = [];
this.Id = null;
this.Name = null;
this.DateCreated = null;
this.IsDeleted = false;
this.SubscriptionName = null;
this.Creator = null;
this.SubscriptionId = null;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
DateCreated:any;
IsDeleted:any;
SubscriptionName:any;
Creator:any;
SubscriptionId:any;
FullName:any;
ProjectRights:any;
static setProjectRights = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectRights == null) $this.ProjectRights = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectRights.length > 0) {
                    Domain.Application.removeProjectRights($this, $this.ProjectRights[0]);
                }

                Domain.Application.addManyProjectRights($this, copyItems);
            }
static addManyProjectRights = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Application.addProjectRights($this, items[i]);
                }
            }
static addProjectRights = ($this, item) => {
                if ($this.ProjectRights == null) $this.ProjectRights = [];
                if (item == null || $this.ProjectRights.indexOf(item) > -1) return;
                $this.ProjectRights.push(item);
if (item.Application != $this) {
Domain.ProjectRights.setApplication(item, $this);
}
}
static addRangeProjectRights = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Application.addProjectRights($this, item));
            }
static removeProjectRights = ($this, item) => {
                if ($this == null || $this.ProjectRights == null || $this.ProjectRights.indexOf(item) === -1) return;
                var _index = $this.ProjectRights.indexOf(item);
                $this.ProjectRights.splice(_index, 1);
item.Application = null;
}
static clearProjectRights = ($this) => { $this.ProjectRights = null; }

static GetFullName($this: any): any{return Joove.Common.safeNumber($this?.Id) + " " + $this?.Name;
}
static GetSelectSQL(wherePart: any): any{return "SELECT " + "Applications.Id as Id, " + "Applications.Name as Name, " + "ApplicationUsers.UserName as Creator," + "DateCreated," + "IsDeleted," + "Subscriptions.Name as Subscription, " + "Subscriptions.Id as SubscriptionId " + "FROM Applications " + "INNER JOIN Subscriptions ON Applications.SubscriptionId = Subscriptions.Id " + "INNER JOIN ApplicationUsers ON Applications.CreatorId = ApplicationUsers.Id " + "WHERE " + wherePart + " " + "ORDER BY Applications.Name DESC";
}
static Serialize(data: any): any{let applications = [];
for (let _irow = 0; _irow < (data == null ? 0 : data.length); _irow++) {let row = data[_irow];applications?.add(Domain.Application.SerializeRow(row));}
return applications;
}
static SerializeRow(row: any): any{let s = new Domain.Application();
s.Id = Joove.Common.cast(row.get("Id"), "number");
s.Name = Joove.Common.cast(row.get("Name"), "string");
if (row.has("IsDeleted")) {s.IsDeleted = Joove.Common.cast(row.get("IsDeleted"), "boolean");}
s.DateCreated = Joove.Common.cast(row.get("DateCreated"), "Date");
if (row.has("Subscription")) {s.SubscriptionName = Joove.Common.cast(row.get("Subscription"), "string");}
if (row.has("SubscriptionId")) {s.SubscriptionId = Joove.Common.cast(row.get("SubscriptionId"), "number");}
s.Creator = Joove.Common.cast(row.get("Creator"), "string");
return s;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}